import React, {useState} from "react";

import {View, Text, ScrollView, StyleSheet, TouchableOpacity, Image, Dimensions, FlatList} from "react-native";

import Config from "../../Config";
import {RFValue} from "react-native-responsive-fontsize";
import {Entypo, EvilIcons, FontAwesome6, Ionicons} from "@expo/vector-icons";
import NumberFormat from "../Components/NumberFormat";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import Toast from "../Components/Toast";
import Loading from "../Components/Loading";


const Buy =({navigation})=>{


    let [data, setData] = useState(false);
    React.useEffect(() => {
        getData();
    },[]);
    let getData = async ()=>{
        try {
            let token = await AsyncStorage.getItem('token');
            let res = await axios.get(`${Config.api}/user/mycourses`,{ 'headers': {  Authorization: 'Bearer '+token} });
            if(res.data.code != 1){
                // alert(JSON.stringify(res.data));
                console.log(res.data);
                Toast(res.data.error);
            }
            setData( res.data);

        } catch (err) {
            console.log(err);
            alert('خطا')
        }
    }


    const renderItem = ({item}) => {


        return (
            <TouchableOpacity onPress={()=>navigation.navigate("Course",{course_id : item.course.id , back : 1 })} key={item.key} style={styles.item}>
                <Image resizeMode={'stretch'} style={styles.image} source={{uri : `${Config.base}/${item.course.image}`}} />
                <View style={styles.subutem}>
                    {/*<Text style={styles.itmtxt}>*/}
                    {/*    دوره*/}
                    {/*</Text>*/}
                    {/*<Text style={styles.itmtitle}>*/}
                    {/*    {item.course.name}*/}
                    {/*</Text>*/}
                </View>
            </TouchableOpacity>
        );
    };


    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <TouchableOpacity style={{flex : 1}} >
                    <Text style={styles.title}>
                        دوره های خریداری شده
                    </Text>
                </TouchableOpacity>




                <TouchableOpacity onPress={()=>{navigation.goBack()}}>
                    <Ionicons style={styles.selficon} name="arrow-back" size={24} color="white" />
                </TouchableOpacity>

            </View>

            {data ?

                <FlatList  contentContainerStyle={styles.content}   keyExtractor={item => item.id}  data={data.courses} renderItem={renderItem} />
                :
                <Loading/>
            }


            {/*<ScrollView style={{flex:1}}>*/}
            {/*    <View style={styles.content}>*/}
            {/*       */}
            {/*        <TouchableOpacity style={styles.item}>*/}
            {/*            <Image style={styles.image} source={require('../../assets/images/course.png')} />*/}
            {/*            <View style={styles.subutem}>*/}
            {/*                <Text style={styles.itmtxt}>*/}
            {/*                    دوره*/}
            {/*                </Text>*/}
            {/*                <Text style={styles.itmtitle}>*/}
            {/*                    انگلیسی در مدرسه*/}
            {/*                </Text>*/}
            {/*            </View>*/}
            {/*        </TouchableOpacity>*/}
            {/*        <TouchableOpacity style={styles.item}>*/}
            {/*            <Image style={styles.image} source={require('../../assets/images/course.png')} />*/}
            {/*            <View style={styles.subutem}>*/}
            {/*                <Text style={styles.itmtxt}>*/}
            {/*                    دوره*/}
            {/*                </Text>*/}
            {/*                <Text style={styles.itmtitle}>*/}
            {/*                    انگلیسی در مدرسه*/}
            {/*                </Text>*/}
            {/*            </View>*/}
            {/*        </TouchableOpacity>*/}
            {/*        <TouchableOpacity style={styles.item}>*/}
            {/*            <Image style={styles.image} source={{uri : 'https://s3-alpha-sig.figma.com/img/154e/58fd/138193365849c369d70e1ee3847faf58?Expires=1736121600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=SXxoKSaWurj5dPi~WG0ZFw6U-l2ECpMUNbsIhoI~4wGRAG6ACjVBnJLy0rfwkROl7PcwKMiKmtkMCSiDkhWjz2ENTDMszF4~pOPCbQqBUXtt5Bp28-KzBoz~UZvKUmgvhvtKoxsii2eAXthJ-H9ZFcjNCEcuB3gG0fMMhj~9ksjAQEFzAfSfrJYLzr3DONWbMHkHuoo1G-eNaKTOGOEcWegibG5BO6rJyT~D-3w3EaUE7~apYNw0tH3ukXprveBPJIie2eHDdf10VA5hY~gcseFLjPRKTTJNWv4CBFnDF9RjKkHlRTW1NHSwD4n8Kz2GqDnis~~owE2KbT9oOf--pQ__'}} />*/}
            {/*            <View style={styles.subutem}>*/}
            {/*                <Text style={styles.itmtxt}>*/}
            {/*                    دوره*/}
            {/*                </Text>*/}
            {/*                <Text style={styles.itmtitle}>*/}
            {/*                    انگلیسی در مدرسه*/}
            {/*                </Text>*/}
            {/*            </View>*/}
            {/*        </TouchableOpacity>*/}
            {/*        <TouchableOpacity style={styles.item}>*/}
            {/*            <Image style={styles.image} source={require('../../assets/images/course.png')} />*/}
            {/*            <View style={styles.subutem}>*/}
            {/*                <Text style={styles.itmtxt}>*/}
            {/*                    دوره*/}
            {/*                </Text>*/}
            {/*                <Text style={styles.itmtitle}>*/}
            {/*                    انگلیسی در مدرسه*/}
            {/*                </Text>*/}
            {/*            </View>*/}
            {/*        </TouchableOpacity>*/}


            {/*    </View>*/}
            {/*</ScrollView>*/}


        </View>
    );
}

const styles = StyleSheet.create({


    subutem:{
      width: '60%',
        justifyContent: 'center',
        alignItems: 'center',
        // backgroundColor : 'red',
        // float: 'left',
        position: 'relative',
        top : -RFValue(125),
        left : -RFValue(110),
    },

    itmtxt : {
      fontSize: RFValue(17),
        fontFamily : 'yk',
        color: 'white',
        textAlign: 'center',
    },
    itmtitle : {
        fontSize: RFValue(17),
        fontFamily : 'yk',
        color: '#0D1134',
        textAlign: 'center',
        backgroundColor: 'white',
        borderRadius: RFValue(18),
        padding: RFValue(8),
        marginTop: RFValue(8),
    },



    image: {
        width: '100%',
        height: RFValue(165),
        borderRadius: RFValue(15),
        marginLeft : RFValue(10),
    },

    item : {
        height: RFValue(165),
        // direction : 'ltr',
      marginBottom : RFValue(15),
    },




    content : {
        flexGrow
            : 1,
        paddingHorizontal: RFValue(20),
        // justifyContent: "center",
        paddingVertical: RFValue(20),
    },

    container : {
        flex: 1,
        backgroundColor: '#FAFAFA',
    },
    header: {

        flexDirection : 'row',
        justifyContent : 'flex-start',
        alignItems : 'center',

        backgroundColor: '#000422',
        paddingHorizontal: RFValue(20),


        shadowColor:"#000000",
        shadowOffset: {
            width: 0,
            height: 50,
        },
        shadowOpacity: 1,
        shadowRadius: 0,
        elevation: 1
    },


    title : {
        fontSize: RFValue(17),
        fontFamily : 'ykb',
        color: '#FFF',
        paddingVertical: RFValue(14),

    },

})


export default Buy